import CurrencyInputField from 'components/molecules/currency-input-field'
import InputField from 'components/molecules/input-field'
import { CitySelectField } from 'components'
import ProvinceSelectField from 'components/organisms/province-select-field'
import { PaymentMethodAsyncMultiSelectSearchField } from 'domains/payment-method/components/'
import { CODE as PRODUCT_ATTRIBUTE } from 'domains/product-attribute/constants'
import ProductAttributeInputSelectField from 'domains/product-attribute/molecules/input-select-field'
import ProductAttributeMultiSelectField from 'domains/product-attribute/molecules/multiselect-field'
import ProductAttributeSelectSearchField from 'domains/product-attribute/molecules/select-search-field'
import ProductCategorySelectField from 'domains/product-category/molecules/select-field'
import ProductCollectionAsyncMultiselectField from 'domains/product-collection/molecules/async-multiselect-field'
import SellerSelectSearchField from 'domains/seller/molecules/select-search-field'
import { CART_ATTRIBUTE } from 'domains/voucher/constants'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'
import { useFormikContext } from 'formik'


const propTypes = {
  name            : PropTypes.string,
  attribute       : PropTypes.object,
  provinces       : PropTypes.array,
  shipmentMethods : PropTypes.array,
  paymentMethods  : PropTypes.array,
  formikBag       : PropTypes.object
}

/**
 * Voucher input value fields. It will render particular field depend on `attribute.code`
 * @param {*} name - Field name
 * @param {*} attributes - Attribute options (can be Product Attributes or Cart Attributes)
 * @param {array} provinces - Province options
 * @param {array} shipmentMethods - Shipment Method options
 * @param {array} paymentMethods - Payment Method option
 */
const VoucherInputValueField = ({
  name,
  attribute,
  shipmentMethods
}) => {
  const formikBag = useFormikContext()

  const getProvinceValue = (formikBag, provinceKey) => {
    const { values: formikValues } = formikBag
    const cartRules                = formikValues[ 'cart_rules' ]

    const tlProvinceRule = cartRules?.find((cartRule) => cartRule.code == provinceKey)
    const provinceValue  = tlProvinceRule?.value

    return provinceValue
  }

  switch (attribute.code) {

    case PRODUCT_ATTRIBUTE.PRICE:
    case CART_ATTRIBUTE.ITEM_PRICE_TOTAL:
    case CART_ATTRIBUTE.SUB_TOTAL:
      return (
        <CurrencyInputField
          name={ name }
          label='value'
          required={ true }
        />
      )

    case PRODUCT_ATTRIBUTE.CATEGORY:
      return (
        <ProductCategorySelectField
          code={ attribute.code }
          name={ name }
          label='value'
          placeholder='Select value'
          required={ true }
        />
      )

    // * We use ProductAttributeSelectSearchField in brand since it has many options (brand has +/- 4500 option!).
    // * To solve performance issue.
    case PRODUCT_ATTRIBUTE.BRAND:
      return (
        <ProductAttributeSelectSearchField
          code={ attribute.code }
          name={ name }
          label={ 'value' }
          placeholder='Select value'
          required={ true }
        />
      )

    case PRODUCT_ATTRIBUTE.CONDITION:
      return (
        <ProductAttributeInputSelectField
          code={ attribute.code }
          name={ name }
          label='value'
          required={ true }
          placeholder='Select value'
        />
      )

    case PRODUCT_ATTRIBUTE.SELLER:
      return (
        <SellerSelectSearchField
          name={ name }
          label='value'
          required={ true }
        />
      )

    case PRODUCT_ATTRIBUTE.COLOUR:
      return (
        <ProductAttributeMultiSelectField
          code={ attribute.code }
          name={ name }
          label='value'
          required={ true }
          placeholder='Select Multiple Color'
        />
      )

    case PRODUCT_ATTRIBUTE.COLLECTION:
      return (
        <ProductCollectionAsyncMultiselectField
          name={ name }
          label='value'
          required={ true }
          placeholder='Select Multiple Collection'
        />
      )

    case CART_ATTRIBUTE.ITEM_QUANTITY:
      return (
        <InputField
          type='number'
          name={ name }
          required={ true }
          label='value'
        />
      )

    case CART_ATTRIBUTE.TL_PAYMENT_METHOD_ID:
      return (
        <PaymentMethodAsyncMultiSelectSearchField
          name={ name }
          label='value'
          required={ true }
          placeholder='Search with Bank Name'
        />
      )

    case CART_ATTRIBUTE.TL_SHIPMENT_METHOD_ID:
      return (
        <InputField
          name={ name }
          type='select'
          required={ true }
          label='value'
        >
          <option value="">select shipment</option>
          {
            shipmentMethods && shipmentMethods.map((shipment, index) => (
              <option
                key={ `conditions-operator-${index}` }
                value={ shipment.id }
              >
                { StringUtil.titleCase(`${shipment.courier} - ${shipment.description}`) }
              </option>
            ))
          }
        </InputField>
      )

    case CART_ATTRIBUTE.TL_PROVINCE_ID:
      return (
        <ProvinceSelectField
          label='Provinsi'
          required={ true }
          name={ name }
        />
      )
    case CART_ATTRIBUTE.TL_CITY_ID:
      return (
        <CitySelectField
          label='Kota'
          required={ true }
          provinceValue={ getProvinceValue(formikBag, 'tl_province_id') }
          name={ name }
        />
      )
    default:
      return (
        <InputField
          type='text'
          required={ true }
          name={ name }
          label='value'
          placeholder='insert the value'
        />
      )
  }
}

VoucherInputValueField.propTypes = propTypes

export default VoucherInputValueField